<div class="m-2 d-flex flex-fill flex-column">
  <dx-data-grid
    #dataGrid
    keyExpr="id"
    class="flex-fill d-flex flex-column"
    [dataSource]="projects"
    (onRowDblClick)="rowDoubleClick($event)"
    >
    <dxi-column dataField="customer.displayName" caption="Company Name" width="175" cellTemplate="linkTemplate"></dxi-column>
    <dxi-column dataField="projectNumber" caption="Project #" width="100" [alignment]="'left'"></dxi-column>
    <dxi-column dataField="name" width="175"></dxi-column>
    <dxi-column dataField="description" width="175"></dxi-column>
    <dxi-column></dxi-column>

    <div *dxTemplate="let cell of 'linkTemplate'">
      @if (cell.data) {
        <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
      }
    </div>

    <dxo-selection mode="multiple"></dxo-selection>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="project-search-grid"></dxo-state-storing>

    <div *dxTemplate="let data of 'toolbarButtons'">
      <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
      <button
        class="btn btn-sm btn-primary me-2"
        (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
        >
        Open
      </button>
      <button
        class="btn btn-sm btn-danger me-1"
        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
        >
        Delete
      </button>
    </div>
    <div *dxTemplate="let data of 'toolbarText'">
      @if (projects) {
        <span class="me-3">
          <strong>
            {{ dataGrid.instance.totalCount() + " items" }}
            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
          </strong>
        </span>
      }
    </div>
  </dx-data-grid>
</div>
